<template>
  <div class="spec-wrapper">
    <section class="sku_section sku-spec" v-for="(specId, index) in specMain" :key="index">
      <div class="section_title">
        <span class="title">{{ specMainSeq[specId] }}</span>
      </div>
      <div class="section_content">
        <div
          class="sku_btn"
          v-for="(specItem, idx) in specItemSeq[specId]"
          :key="'idx' + idx"
          :class="{
            'sku_btn--checked':
              checkedSpecItem[specId] && checkedSpecItem[specId].id - 1 === idx && !isDisabled(specId, idx + 1),
            'sku_btn--dashed': isDashed(specId, idx + 1),
            'sku_btn--disabled': isDisabled(specId, idx + 1)
          }"
          @click="selectSpecItem(specId, idx + 1, specMainSeq[specId], specItem.name)"
        >
          <span
            tabindex="0"
            :aria-label="
              checkedSpecItem[specId] && checkedSpecItem[specId].id - 1 === idx && !isDisabled(specId, idx + 1)
                ? '已选中,' + specItem.name.replace(/@/, ' ') + (isDisabled(specId, idx + 1) ? ',已停用' : '')
                : '未选中,' +
                  specItem.name.replace(/@/, ' ') +
                  (isDisabled(specId, idx + 1) ? ',已停用' : ',点按两次可选中')
            "
          >
            {{ specItem.name | formatSpecName }}
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import skuEventBus from '../../eventBus'
import { vm as skuSelect } from '../../sku'
// import getAvaiSpecs from './spec'
// import specData from './data'

export default {
  name: 'SkuSpec',
  filters: {
    // 如果规格名字中有@符号，则将@符号替换为空格
    formatSpecName(str) {
      return str.replace(/@/, ' ')
    }
  },
  props: ['spuInfo', 'specMain', 'specMainSeq', 'skuSpecList', 'specItemSeq', 'skuId'],
  data() {
    return {
      // 记录已选中的规格项， 形如{0: {id: 1, name: '全网通64g'}}的形式
      checkedSpecItem: {},
      availableSpecItems: [], // 知否有该规格项
      storeSpecItems: [] // 该规格项是否有库存
    }
  },
  computed: {
    // 可选选项
    specAvaiArr() {
      return this.availableSpecItems[this.specIdIndex] || []
    },
    // 有库存的选项
    specStoreArr() {
      return this.storeSpecItems[this.specIdIndex] || []
    }
  },
  created() {
    // 初始化选中数据
    this.initCheckedSpecs()
    // 注册通信事件
    this.bindEvent()
  },
  mounted() {
    // 初始化选中数据
    if (skuSelect) {
      const { availableSpecItems, storeSpecItems, checked } = skuSelect?.getInitData()
      this.availableSpecItems = availableSpecItems
      this.storeSpecItems = storeSpecItems
      if (checked) {
        this.checkedSpecItem = checked
      }
    }
  },
  methods: {
    reInitSkuSpecSelect(skuId) {
      // 根据skuId找到对应的sku项
      const currentSku = this.skuSpecList.find(item => item.skuId == skuId)
      let skuSpecs = {}

      if (currentSku) {
        skuSpecs = currentSku.sequences
      }
      this.specMain.forEach(specId => {
        // 当前sku不存在的话，则选中项初始化为空值
        const specItemId = skuSpecs[specId] || ''
        let specItemName = ''
        if (specItemId) {
          specItemName = this.specItemSeq[specId][specItemId - 1].name
        }
        this.$set(this.checkedSpecItem, specId, {
          id: specItemId,
          name: specItemName
        })
        const { availableSpecItems, storeSpecItems } = skuSelect?.getInitData()
        this.availableSpecItems = availableSpecItems
        this.storeSpecItems = storeSpecItems
      })
    },
    initCheckedSpecs() {
      this.specMain.forEach(specId => {
        this.$set(this.checkedSpecItem, specId, null)
      })
    },
    /**
     * 注册通信事件，以供版本外显等模块直接驱动sku选择逻辑
     */
    bindEvent() {
      // 规格项可选情况发生变化
      skuEventBus.$on('avaiSpecChange', (availableSpecItems, storeSpecItems) => {
        this.availableSpecItems = availableSpecItems
        this.storeSpecItems = storeSpecItems
      })
      // 规格项选中变化
      skuEventBus.$on('checkedSpecChange', ({ specId, specItemId, specName, specItemName }) => {
        this.$set(this.checkedSpecItem, specId, {
          id: specItemId,
          name: specItemName
        })
      })
    },
    /**
     * 选中某个规格项
     */
    selectSpecItem(specId, specItemId, specName, specItemName) {
      if (this.checkedSpecItem[specId]?.id == specItemId) return
      console.log('click')
      skuEventBus.$emit('selectSpecItem', {
        specId,
        specItemId,
        specName,
        specItemName
      })
    },
    // 该规格是否不可选,该状态不能加载第一规格项上
    isDisabled(specId, specItemId) {
      const index = this.specMain.indexOf(specId)
      return !this.isFirstSpec(specId) && this.availableSpecItems[index]?.indexOf(specItemId + '') < 0
    },

    // 该规格项是否是下架或无货,该状态不能加载第一规格项上
    isDashed(specId, specItemId) {
      const index = this.specMain.indexOf(specId)
      // 该规格项不是第一规格项，且该规格项是可选规格项，且规格项不为有库存规格项 才加下架缺货状态
      return (
        !this.isFirstSpec(specId) &&
        this.availableSpecItems[index]?.indexOf(specItemId + '') >= 0 &&
        this.storeSpecItems[index]?.indexOf(specItemId + '') < 0
      )
    },

    // 判断某个规格项是否是第一规格项，缺货和不可选状态不能加到第一规格项上
    isFirstSpec(specId) {
      // 规格项有多个，且该规格项为第一个，则为第一规格项
      if (this.specMain.length > 1 && this.specMain[0] == specId) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
